import { render, staticRenderFns } from "./SidebarPagesNav.vue?vue&type=template&id=66b13ee0&lang=pug"
import script from "./SidebarPagesNav.vue?vue&type=script&lang=ts"
export * from "./SidebarPagesNav.vue?vue&type=script&lang=ts"
import style0 from "./SidebarPagesNav.vue?vue&type=style&index=0&id=66b13ee0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports